
class AttachmentDialogResult {
    constructor() {

        /** @type {FileInRepository[]}  */
        this.attachmentsList = null;
        /** @type {Number}  */
        this.numberOfUnsavedAttachments = null;
        /** @type {Boolean}  */
        this.isSavedClicked = null;
    }
}

export { AttachmentDialogResult }
